module.exports = __webpack_public_path__ + "static/media/r175.72c6b66d.jpg";